<template>
    <div class="col-sm-12 d-flex flex-wrap py-3">

        <add-extra :reservation="reservation" v-if="reservation.event.product" class="w-100"></add-extra>

        <div class="text-center fs-large dark w-100" v-else>
            No extras available
        </div>

    </div>
</template>

<script>
import AddExtra from '@/components/reservations/NewReservation/Resume/AddExtra/AddExtra'

export default {
    data: function() {
        return {

        }
    },
    props:{
        reservation:{
            type: Object
        }
    },
    components: {
        AddExtra
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// TabAddExtras.vue?a1d1e37a